import React, { useEffect, useState } from "react";
import { Card, Input, Typography, Button, Form } from "antd";
import { useTranslation } from "react-i18next";
import styles from "./DeleteAccount.module.scss";
import { deleteUserAccount } from "../../../redux/services/common/commonServices";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { routes } from "../../../constants";

const DeleteAccount = () => {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const { t } = useTranslation("deleteAccount");
  const [enableDelete, setEnableDelete] = useState(true);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const onFinish = async (values) => {
    let dataToBeSent = {
      emailOrPhoneNumber: values.email,
      password: values.password,
    };
    dispatch(deleteUserAccount(dataToBeSent)).then((apiRes) => {
      navigate(routes.SIGN_IN);
    });
  };

  const onValueChange = (allValues) => {
    if (
      allValues.confirmation === "delete" &&
      allValues.password &&
      allValues.email
    ) {
      setEnableDelete(false);
    } else {
      setEnableDelete(true);
    }
  };

  return (
    <div className={styles.container}>
      <Card className={styles.cardContainer}>
        <Typography.Title level={3} className={styles.deleteTitle}>
          {t("title")}
        </Typography.Title>
        <div>
          <Typography.Paragraph level={4} className={styles.deleteDescription}>
            {t("irreversibleAction")}
          </Typography.Paragraph>
        </div>
        <Form
          layout="vertical"
          onFinish={onFinish}
          initialValues={{ confirmation: "" }}
          className={styles.formContainer}
          requiredMark={false}
          onValuesChange={(changedValues, allValues) => {
            onValueChange(allValues);
            form.setFieldsValue(allValues);
          }}
        >
          <Form.Item
            label={t("emailLabel")}
            name="email"
            rules={[
              {
                type: "email",
                message: t("emailValidationMessage"),
              },
              {
                required: true,
                message: t("emailRequiredMessage"),
              },
            ]}
          >
            <Input className={styles.inputField} />
          </Form.Item>
          <Form.Item
            label={t("passwordLabel")}
            name="password"
            rules={[
              {
                required: true,
                message: t("passwordRequiredMessage"),
              },
            ]}
          >
            <Input.Password className={styles.inputField} />
          </Form.Item>
          <Form.Item
            label={t("confirmationLabel")}
            name="confirmation"
            rules={[
              {
                required: true,
                message: t("confirmationValidationMessage"),
                validator: (_, value) =>
                  value.toLowerCase() === "delete"
                    ? Promise.resolve()
                    : Promise.reject(t("confirmationValidationMessage")),
              },
            ]}
          >
            <Input
              placeholder={t("confirmationValidationMessage")}
              className={styles.inputField}
            />
          </Form.Item>
          <Form.Item>
            <Button
              type="primary"
              htmlType="submit"
              className={styles.deleteButton}
              danger={!enableDelete}
              loading={loading}
              disabled={enableDelete}
            >
              {t("deleteButton")}
            </Button>
          </Form.Item>
        </Form>
      </Card>
    </div>
  );
};

export default DeleteAccount;
